(() => {
  'use strict';
  if (window.__tpDingDoongCheckoutSyncV5) return;
  window.__tpDingDoongCheckoutSyncV5 = true;

  const cartPage = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(location.pathname);
  const rootPath = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const cartUrl = rootPath + 'cart';
  const checkoutSelector = 'button[name="checkout"], #checkout.cart__checkout-button, button.cart__checkout-button';
  const acceleratedSelector = '.additional-checkout-buttons, .cart__additional-checkout-buttons, shopify-accelerated-checkout-cart';
  let resuming = false;
  let pending = null;
  let refreshTimer = 0;
  let remainingDateChecks = 0;
  let observingApp = null;

  const calendarMonths = {januar:1,jan:1,january:1,februar:2,feb:2,february:2,maerz:3,marz:3,märz:3,mar:3,march:3,april:4,apr:4,mai:5,may:5,juni:6,jun:6,june:6,juli:7,jul:7,july:7,august:8,aug:8,september:9,sep:9,sept:9,oktober:10,okt:10,october:10,oct:10,november:11,nov:11,dezember:12,dez:12,december:12,dec:12};
  const isoFromParts = (y, m, d) => {
    const year = Number(y), month = Number(m), day = Number(d);
    const dt = new Date(Date.UTC(year, month - 1, day));
    if (year < 2025 || year > 2038 || dt.getUTCFullYear() !== year || dt.getUTCMonth() !== month - 1 || dt.getUTCDate() !== day) return '';
    return [String(year), String(month).padStart(2, '0'), String(day).padStart(2, '0')].join('-');
  };
  const parseDate = value => {
    const text = String(value || '').trim();
    let m = text.match(/\b(20\d{2})[-/.](\d{1,2})[-/.](\d{1,2})\b/);
    if (m) return isoFromParts(m[1], m[2], m[3]);
    m = text.match(/\b(\d{1,2})[./-](\d{1,2})[./-](20\d{2})\b/);
    if (m) return isoFromParts(m[3], m[2], m[1]);
    m = text.match(/(\d{1,2})\.?\s+([a-zäöü]+)\.?,?\s+(20\d{2})/i);
    if (m && calendarMonths[m[2].toLowerCase()]) return isoFromParts(m[3], calendarMonths[m[2].toLowerCase()], m[1]);
    m = text.match(/([a-zäöü]+)\.?\s+(\d{1,2}),?\s+(20\d{2})/i);
    if (m && calendarMonths[m[1].toLowerCase()]) return isoFromParts(m[3], calendarMonths[m[1].toLowerCase()], m[2]);
    return '';
  };
  const slashDate = iso => {
    const [year, month, day] = iso.split('-');
    return [day, month, year].join('/');
  };
  const setState = (value, selection) => {
    document.documentElement.dataset.tpDingDoongDateSync = value;
    const title = document.querySelector('.tp-cart-top__notice strong');
    if (!title) return;
    let label = 'Bitte Liefer- oder Abholdatum auswählen';
    if (value === 'pending') label = 'Liefer- oder Abholtermin wird geprüft …';
    if (value === 'ready' && selection) {
      const calendars = Array.from(dingDoongRoot()?.querySelectorAll('.ot-dingdoong-calendar__popover-button') || [])
        .filter(element => element.getClientRects().length);
      const displayed = calendars.length === 1
        ? parseDate(calendars[0].textContent + ' ' + (calendars[0].getAttribute('aria-label') || ''))
        : dateFromCalendar(selection.channel);
      if (displayed === selection.date || (!calendars.length && !displayed)) {
        const type = selection.channel === 'PICKUP' ? 'Abholtermin' : 'Liefertermin';
        const date = selection.date.split('-').reverse().join('.');
        label = type + ' für den ' + date + ' übernommen';
      }
    }
    if (title.textContent.trim() !== label) title.textContent = label;
  };
  const showMessage = message => {
    if (!cartPage) return;
    const anchor = document.querySelector('.cart__ctas') || document.querySelector('#checkout');
    if (!anchor) return;
    let node = document.querySelector('[data-tp-checkout-date-notice]');
    if (!node) {
      node = document.createElement('div');
      node.dataset.tpCheckoutDateNotice = '';
      node.setAttribute('role', 'alert');
      node.style.cssText = 'margin:8px 0 12px;padding:12px 14px;border:1px solid #e5b1a5;border-left:4px solid #ba3927;border-radius:10px;background:#fff6f3;color:#61241b;font-size:13px;line-height:1.5;';
      anchor.before(node);
    }
    node.textContent = message;
    node.scrollIntoView?.({block:'nearest',behavior:'smooth'});
  };
  const clearMessage = () => document.querySelector('[data-tp-checkout-date-notice]')?.remove();
  const getCart = async () => {
    const response = await fetch(rootPath + 'cart.js', {credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error('Der Warenkorb konnte nicht gelesen werden. Bitte versuche es erneut.');
    return response.json();
  };
  const deepRoots = () => {
    const roots = [document];
    for (let i = 0; i < roots.length; i += 1) {
      roots[i].querySelectorAll?.('*').forEach(element => {
        if (element.shadowRoot && !roots.includes(element.shadowRoot)) roots.push(element.shadowRoot);
      });
    }
    return roots;
  };
  const dingDoongRoot = () => {
    for (const root of deepRoots()) {
      const app = root.querySelector?.('#dingdoong-embedded-render-root');
      if (app) return app;
    }
    return null;
  };
  const dateFromCalendar = channel => {
    const app = dingDoongRoot();
    if (!app) return '';
    const pickup = channel === 'PICKUP';
    const openers = Array.from(app.querySelectorAll('.ot-dingdoong-calendar__popover-button, button[aria-label], [role="button"][aria-label], [role="button"][aria-labelledby]'));
    const match = openers.find(element => {
      if (!element.getClientRects().length) return false;
      const labelIds = (element.getAttribute('aria-labelledby') || '').split(/\s+/).filter(Boolean);
      const labels = labelIds.map(id => element.getRootNode().getElementById?.(id)?.textContent || '');
      const label = [element.textContent, element.getAttribute('aria-label'), ...labels].join(' ').toLowerCase();
      return pickup
        ? /abholdatum|abholtermin|pickup date/.test(label)
        : /lieferdatum|liefertermin|delivery date|shipping date/.test(label);
    });
    return match ? parseDate(String(match.textContent || '') + ' ' + String(match.getAttribute('aria-label') || '')) : '';
  };
  const channelFor = attributes => {
    const appChannel = String(attributes.ot_channel || '').toUpperCase();
    if (appChannel === 'PICKUP' || appChannel === 'SHIPPING') return appChannel;
    const saved = String(attributes['Checkout channel'] || '').toUpperCase();
    if (saved === 'PICKUP' || saved === 'SHIPPING') return saved;
    if (parseDate(attributes['Pickup date']) || parseDate(attributes.Abholdatum)) return 'PICKUP';
    if (parseDate(attributes['Shipping date']) || parseDate(attributes.Versanddatum)) return 'SHIPPING';
    return '';
  };
  // Only accept a pickup location that DingDoong has actually selected.
  // The app sometimes renders a checked location before it persists "Location"
  // in /cart.js. Visible unselected addresses must NEVER unlock checkout.
  const pickupSites = [
    {key:'laatzen', name:'CARBO Hannover', address:'Meineckestraße 12-14, Laatzen, 30880, Germany',
      aliases:['carbo hannover','laatzen','meineckestrasse','30880']},
    {key:'bad-hoenningen', name:'CARBO Bad Hönningen', address:'Sprudelstraße 1, Bad Hönningen, 53557, Germany',
      aliases:['carbo bad honningen','bad honningen','bad hoenningen','sprudelstrasse','53557']},
    {key:'nordhorn', name:'Coditec GmbH', address:'Enschedestraße 39, Nordhorn, 48529, Germany',
      aliases:['coditec','nordhorn','enschedestrasse','48529']}
  ];
  const normalizeLocation = value => String(value || '').normalize('NFKD')
    .replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/ß/g,'ss')
    .replace(/[^a-z0-9]+/g,' ').replace(/\s+/g,' ').trim();
  const recognizePickupSite = value => {
    const text = ' ' + normalizeLocation(value) + ' ';
    if (!text.trim()) return null;
    const matches = pickupSites.filter(site =>
      site.aliases.some(alias => text.includes(' ' + normalizeLocation(alias) + ' '))
    );
    return matches.length === 1 ? matches[0] : null;
  };
  const selectedPickupSite = app => {
    if (!app) return null;
    const selectors = [
      'input[type="radio"]:checked','[role="radio"][aria-checked="true"]',
      '[aria-selected="true"]','[data-selected="true"]',
      '[data-state="checked"]','option:checked',
      '[class*="--selected"]','[class*="--active"]',
      '[class*="is-selected"]','[class*="is-active"]',
      '[class*="selected"]'
    ].join(',');
    const selected = new Map();
    for (const element of app.querySelectorAll(selectors)) {
      // A checked "Abholung" delivery-method control contains no unique
      // location and cannot be mistaken for a selected pickup site.
      let node = element;
      for (let depth = 0; node && node !== app && depth <= 5; depth++, node = node.parentElement) {
        const text = [node.textContent, node.value, node.getAttribute?.('aria-label')].filter(Boolean).join(' ');
        if (text.length > 300) break; // prevent entire location lists matching
        const site = recognizePickupSite(text);
        if (site) { selected.set(site.key, site); break; }
      }
    }
    return selected.size === 1 ? [...selected.values()][0] : null;
  };
  const pickupSiteFromAttributes = attributes => {
    const values = [
      'Location','Abholstandort','Pickup location','Pickup Location',
      'Pickup location name','Pickup Location Name','Pickup store',
      'Store location','Store','Address'
    ].map(key => attributes[key]).filter(value => String(value || '').trim());
    const matches = new Map();
    for (const value of values) {
      const site = recognizePickupSite(value);
      if (site) matches.set(site.key,site);
    }
    return matches.size === 1 ? [...matches.values()][0] : null;
  };

  // Eingaben, die der Kunde erst noch im Kalender auswählen muss, werden nicht
  // bereits beim Seitenladen als zweite Fehlermeldung angezeigt.
  const missingSelection = (message, retry = false) => {
    const error = new Error(message);
    error.tpNeedsSelection = true;
    error.tpDatePending = retry;
    return error;
  };

  // DingDoong schreibt sein eigenes 'Shipping date'/'Pickup date' unmittelbar in
  // cart.attributes. Dies ist die Primärquelle; die sichtbare Kalenderbeschriftung
  // ist lediglich eine zusätzliche Plausibilitätskontrolle.
  const inspect = async () => {
    const cart = await getCart();
    const attributes = cart.attributes || {};
    if (!cart.item_count) throw new Error('Dein Warenkorb ist leer.');

    const channel = channelFor(attributes);
    if (!channel) throw missingSelection('Bitte wähle aus, ob du eine Lieferung oder Abholung möchtest.');
    const pickup = channel === 'PICKUP';
    const primaryKey = pickup ? 'Pickup date' : 'Shipping date';
    const secondaryKey = pickup ? 'Abholdatum' : 'Versanddatum';
    const primaryValue = String(attributes[primaryKey] || '').trim();
    const primaryDate = parseDate(primaryValue);
    const secondaryDate = parseDate(attributes[secondaryKey]);
    const app = dingDoongRoot();
    const visibleDate = app ? dateFromCalendar(channel) : '';

    // Nur das app-eigene Attribut gilt als Beleg einer DingDoong-Auswahl.
    // Ein vom Bestellpiloten übernommener Wert allein genügt nicht.
    if (!primaryDate) {
      throw missingSelection(pickup
        ? 'Bitte wähle ein Abholdatum und eine Abholzeit aus.'
        : 'Bitte wähle dein gewünschtes Lieferdatum aus.', Boolean(visibleDate));
    }
    // Konflikte werden nicht stillschweigend mit einem anderen Datum überschrieben.
    if (visibleDate && visibleDate !== primaryDate) {
      throw missingSelection('Deine Terminauswahl wird gerade aktualisiert. Bitte warte einen Moment und versuche es erneut.', true);
    }
    // An old display alias can be refreshed only when the visible calendar
    // and DingDoong's own persisted date independently confirm the new value.
    if (secondaryDate && secondaryDate !== primaryDate && visibleDate !== primaryDate) {
      throw new Error('Dein ausgewählter Termin hat sich geändert. Bitte wähle das Datum noch einmal aus.');
    }
    const otherPrimary = parseDate(attributes[pickup ? 'Shipping date' : 'Pickup date']);
    if (otherPrimary && !String(attributes.ot_channel || '').trim()) {
      throw new Error('Es sind widersprüchliche Versand- und Abholtermine vorhanden. Bitte wähle die gewünschte Lieferart erneut.');
    }

    let confirmedPickupSite = null;
    if (pickup) {
      const visibleSite = selectedPickupSite(app);
      const savedSite = pickupSiteFromAttributes(attributes);
      const time = String(attributes['Pickup time'] || '').trim();
      // A positively checked radio/location card is authoritative if the
      // native attribute is absent or has not yet caught up with a change.
      confirmedPickupSite = visibleSite || savedSite;
      if (!confirmedPickupSite) throw missingSelection('Bitte wähle einen Abholstandort aus.');
      if (!time) throw missingSelection('Bitte wähle eine Abholzeit aus.');
    }

    const date = primaryDate;
    const normalizedDate = slashDate(date);
    const changes = {};
    // Die nativen DingDoong-Felder NICHT umformatieren. Shopify-DingDoong
    // benötigt sie z.B. als YYYY-MM-DD. Nur die eigenen Anzeige-Aliase anpassen.
    if (attributes[secondaryKey] !== normalizedDate) changes[secondaryKey] = normalizedDate;
    if (attributes['Checkout channel'] !== channel) changes['Checkout channel'] = channel;
    if (pickup && confirmedPickupSite) {
      // Persist the validated DingDoong selection before Shopify sends the
      // order-confirmation email. Do not fabricate a choice from the options.
      if (attributes.Location !== confirmedPickupSite.name) changes.Location = confirmedPickupSite.name;
      if (attributes.Abholstandort !== confirmedPickupSite.name) changes.Abholstandort = confirmedPickupSite.name;
      if (attributes.Address !== confirmedPickupSite.address) changes.Address = confirmedPickupSite.address;
    }
    for (const staleKey of (pickup ? ['Shipping date','Versanddatum'] : ['Pickup date','Abholdatum'])) {
      if (attributes[staleKey]) changes[staleKey] = '';
    }
    if (!pickup && attributes['Pickup time']) changes['Pickup time'] = '';

    if (attributes.tp_date_verified !== 'YES') changes.tp_date_verified = 'YES';
    if (attributes.tp_confirmed_date !== normalizedDate) changes.tp_confirmed_date = normalizedDate;
    if (attributes.tp_confirmed_channel !== channel) changes.tp_confirmed_channel = channel;
    const source = visibleDate ? 'DINGDOONG_CART_AND_CALENDAR' : 'DINGDOONG_CART';
    if (attributes.tp_date_source !== source) changes.tp_date_source = source;
    const confirmedTime = pickup ? String(attributes['Pickup time'] || '').trim() : '';
    if (String(attributes.tp_confirmed_time || '') !== confirmedTime) changes.tp_confirmed_time = confirmedTime;

    return {attributes, changes, channel, date, primaryKey, secondaryKey, pickupSite: confirmedPickupSite};
  };
  let lastError = '';
  const sync = async (showInputWarnings = false) => {
    if (pending) {
      // Wird die Prüfung während einer Kundenaktion bereits im Hintergrund
      // ausgeführt, den Fehler beim bewussten Checkout-Versuch trotzdem zeigen.
      return showInputWarnings
        ? pending.then(ok => {
            if (!ok) showMessage(lastError || 'Bitte prüfe deinen Liefer- oder Abholtermin.');
            return ok;
          })
        : pending;
    }
    lastError = '';
    setState('pending');
    pending = (async () => {
      const inspected = await inspect();
      if (Object.keys(inspected.changes).length) {
        const response = await fetch(rootPath + 'cart/update.js', {
          method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({attributes:{...inspected.attributes,...inspected.changes}})
        });
        if (!response.ok) throw new Error('Der gewählte Termin konnte nicht im Warenkorb gespeichert werden. Bitte erneut versuchen.');
      }
      const verified = await getCart();
      const saved = verified.attributes || {};
      if (parseDate(saved[inspected.primaryKey]) !== inspected.date || parseDate(saved[inspected.secondaryKey]) !== inspected.date || saved['Checkout channel'] !== inspected.channel || saved.tp_date_verified !== 'YES') {
        throw new Error('Der Termin wurde nicht eindeutig übernommen. Bitte wähle ihn erneut und versuche es noch einmal.');
      }
      if (inspected.channel === 'PICKUP' &&
          (recognizePickupSite(saved.Location)?.key !== inspected.pickupSite?.key ||
           recognizePickupSite(saved.Abholstandort)?.key !== inspected.pickupSite?.key ||
           !String(saved['Pickup time'] || '').trim())) {
        throw new Error('Der Abholstandort wurde noch nicht eindeutig gespeichert. Bitte prüfe den Standort und versuche es erneut.');
      }
      clearMessage();
      setState('ready', inspected);
      return true;
    })().catch(error => {
      lastError = String(error?.message || 'Unbekannter Terminfehler');
      if (!showInputWarnings && error?.tpDatePending && remainingDateChecks > 0) {
        remainingDateChecks -= 1;
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(() => sync(), 1200);
        return false;
      }
      setState('error');
      if (showInputWarnings || !error?.tpNeedsSelection) {
        showMessage(error?.message || 'Bitte überprüfe den gewählten Liefer- oder Abholtermin.');
      } else {
        // Der Kalender zeigt bei unvollständiger Auswahl bereits selbst die
        // erforderlichen Felder. Keine doppelte rote Warnung am Warenkorbende.
        clearMessage();
      }
      return false;
    }).finally(() => {pending = null;});
    return pending;
  };
  const schedule = (delay = 700) => {
    if (!cartPage) return;
    remainingDateChecks = 5;
    setState('pending');
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {sync();}, delay);
  };

  document.addEventListener('click', event => {
    if (resuming) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const checkout = target.closest(checkoutSelector);
    if (checkout) {
      if (!cartPage) {
        if (checkout.closest('.cart-drawer, cart-drawer-component, cart-items-component, #header-group')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          location.assign(cartUrl);
        }
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      sync(true).then(ok => {
        if (!ok || !checkout.isConnected) return;
        resuming = true;
        try {checkout.click();} finally {resuming = false;}
      });
      return;
    }
    if (!cartPage) return;
    if (target.closest(acceleratedSelector) && document.documentElement.dataset.tpDingDoongDateSync !== 'ready') {
      event.preventDefault();
      event.stopImmediatePropagation();
      showMessage('Bitte wähle zuerst deinen Liefer- oder Abholtermin aus.');
      return;
    }
    if (target.closest('#dingdoong-embedded-render-root')) schedule(950);
  }, true);

  document.addEventListener('submit', event => {
    if (resuming || !cartPage) return;
    const button = event.submitter;
    if (!button?.matches?.(checkoutSelector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    sync(true).then(ok => {
      if (!ok) return;
      resuming = true;
      try {event.target.requestSubmit(button);} finally {resuming = false;}
    });
  }, true);

  const cartCopy = new Map([
    ['Wählen Sie einen Termin, der für Sie am besten passt', 'Wähle deinen Wunschtermin'],
    ['Wählen Sie Ihren Abholort:', 'Wähle deinen Abholort:'],
    ['Bitte wählen Sie vor dem Bezahlen ein Versanddatum und eine Versandzeit aus',
      'Wähle vor dem Bezahlen deinen Liefertermin und, falls angezeigt, das Zeitfenster.'],
    ['Bitte wählen Sie vor dem Bezahlen ein Abholdatum und eine Abholzeit aus.',
      'Wähle vor dem Bezahlen dein Abholdatum und deine Abholzeit.']
  ]);
  const updateCartCopy = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      for (const [original, replacement] of cartCopy) {
        if (node.data.includes(original)) node.data = node.data.replace(original, replacement);
      }
    }
  };

  const start = () => {
    if (!cartPage) return;
    setState('pending');
    document.addEventListener('change', event => {
      if (event.target instanceof Element && event.target.closest('#dingdoong-embedded-render-root')) schedule(700);
    }, true);
    const observer = new MutationObserver(records => {
      updateCartCopy(observingApp);
      if (records.some(record => record.type === 'childList')) schedule(800);
    });
    const attach = () => {
      const app = dingDoongRoot();
      if (app && app !== observingApp) {
        observer.disconnect();
        observingApp = app;
        updateCartCopy(app);
        observer.observe(app, {subtree:true,childList:true,characterData:true});
        schedule(500);
      }
    };
    const appTimer = setInterval(attach, 1200);
    setTimeout(() => {clearInterval(appTimer);}, 24000);
    attach();
    schedule(1400);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
